import { render, staticRenderFns } from "./photo-fullscreen.vue?vue&type=template&id=6537500a&scoped=true&"
import script from "./photo-fullscreen.vue?vue&type=script&lang=js&"
export * from "./photo-fullscreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6537500a",
  null
  
)

export default component.exports